export * from './core.reducer';



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/core/reducers/index.ts